export enum EvaluationsByFranchiseOrderingEnum {
    FRANCHISE = 'FRANCHISE',
    PLANNEDS_TODAY = 'PLANNEDS_TODAY',
    SCHEDULEDS_TODAY = 'SCHEDULEDS_TODAY',
    SCHEDULEDS_TOMORROW = 'SCHEDULEDS_TOMORROW',
    SCHEDULEDS_MORE_48HRS = 'SCHEDULEDS_MORE_48HRS',
}
